import { useQuery } from '@tanstack/react-query';
import { findAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
export function useGetAgent({ agentId }) {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const action = user ? findAction(user, 'getAgent') : null;
    return useQuery({
        queryKey: ['getAgent', user?.email, agentId],
        enabled: Boolean(user && action && agentId),
        queryFn: async () => {
            if (!user || !action)
                throw new Error('getAgent unavailable');
            const response = await invokeAction(action, user.token, {
                variables: { UUID: agentId },
            });
            if (!response.ok)
                throw new Error(`getAgent returned ${response.status}`);
            const json = (await response.json());
            const agent = json.object;
            if (!agent)
                throw new Error('getAgent response missing object');
            return agent;
        },
    });
}
